import { PureComponent } from 'react'
import List from 'react-virtualized/dist/commonjs/List'
import styled from 'glamorous'
import { $ } from 'utils'
import noop from 'lodash/noop'

class VirtualizedSelect extends PureComponent {

  static defaultProps = {
    onSelect: noop,
    value: 1
  }

  state = {
    options: this.props.options || [],
    inputValue: this.props.value,
    showList: false
  }

  componentWillReceiveProps(nextProps) {
    const newState = { inputValue: nextProps.value }
    if (nextProps.options.length !== this.props.options.length) {
      newState.options = nextProps.options
    }
    this.setState(newState)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick)
  }

  handleDocumentClick = (e) => {
    if (!this.node.contains(e.target)) {
      this.reset()
    }
  }

  handleSelect = (value) => () => {
    this.props.onChange(value)
    this.reset()
  }

  reset = () => {
    this.showList(false)
    this.setState({ inputValue: this.props.value })
  }

  rowRenderer = ({
    key,
    index,
    isScrolling,
    isVisible,
    style
  }) =>
    $(ListItem, {
      key,
      style,
      onClick: this.handleSelect(this.state.options[index])
    }, this.state.options[index])

  onChange = (e) => {
    if (e.target.value === '' || (/^([1-9][0-9]*)$/.test(e.target.value)
        && e.target.value <= this.props.options.length)) {
      this.setState({inputValue: e.target.value})
      if (e.target.value !== '') {
        this.props.onChange(e.target.value)
      }
    }
  }

  showList = (value) =>
    this.setState({ showList: value })

  render = () =>
    $(Container, {
        innerRef: node => this.node = node
      },
      $(InputContainer, {
        type: 'text',
        innerRef: input => this.input = input,
        value: this.state.inputValue,
        onChange: this.onChange,
        placeholder: 'Select...'
      }),
      $(ArrowIcon, { onClick: () => this.showList(!this.state.showList) }),
      $(ListContainer, { shown: this.state.showList },
        $(List, {
          width: 96,
          height: this.state.options.length > 5 ? 150 : this.state.options.length * 30,
          rowCount: this.state.options.length,
          rowHeight: 30,
          rowRenderer: this.rowRenderer,
        })
      )
    )
}

export default VirtualizedSelect

const Container = styled.div({
  position: 'relative',
  display: 'flex',
  flexFlow: 'row nowrap',
  border: '1px solid #d9d9d9',
  borderRadius: 2,
  boxSizing: 'border-box'
})

const InputContainer = styled.input({
  padding: '0 10px',
  width: 70,
  height: 32,
  border: 'none',
  boxSizing: 'border-box'
})

const ListContainer = styled.div({
  display: 'none',
  position: 'absolute',
  top: '100%',
  left: -1,
  background: 'var(--white)',
  border: '1px solid #d9d9d9',
  borderTop: 'none',
  borderRadius: '0 0 2px 2px',
  boxSizing: 'border-box',
  zIndex: 999
}, ({ shown }) => ({
  ...shown && {
    display: 'block'
  }
}))

const ListItem = styled.div({
  padding: '0 10px',
  height: 30,
  lineHeight: '30px',
  cursor: 'pointer',
  userSelect: 'none',
  '&:hover': {
    background: '#f0f0f0'
  }
})

const ArrowIcon = styled.span({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2px 10px 0 6px',
  cursor: 'pointer',
  '&:before' : {
    content: ' ',
    position: 'relative',
    display: 'inline-block',
    height: 0,
    width: 0,
    borderColor: '#999 transparent transparent',
    borderStyle: 'solid',
    borderWidth: '5px 5px 2.5px',
  },
  '&:hover:before': {
    borderColor: '#bbb transparent transparent'
  }
})


// WEBPACK FOOTER //
// ./src/components/VirtualizedSelect.js